export default class Helper {

    static formatCM(value) {
        return I18N.formatFloat(value, 1) + ' cm';
    }

    static formatMoney(value) {
        return I18N.formatFloat(value, 2) + ' ' + APP.settings.currencySymbol;
    }

    static round(val, decimals=2) {
        const mul = Math.pow(10,decimals);
        return Math.round(val * mul) / mul;
    }

    static parseFloat(val, decimals=2) {
        return I18N.parseFloat(val, decimals);
    }

    static formatNum(val, decimals=1) {
        return I18N.formatFloat(val, decimals);
    }

}

$.fn.isVisible = function () {
    return !!(this.offsetWidth || this.offsetHeight || _.get(this, '[0].getClientRects().length'));
};
